import { createFileRoute } from '@tanstack/react-router'
import { RequirePermission } from '@/shared/components'
import { BalancePage } from '@/pages/balance/BalancePage'

export const Route = createFileRoute('/legal-entity-ledger')({
  component: () => (
    <RequirePermission section="balance" action="view">
      <BalancePage />
    </RequirePermission>
  ),
})
